import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { labs } from "lobbie";

export interface ILabVendorConfigDrawer {
    show: boolean;
    onCloseDrawer?: () => void;
    labVendor?:
        | labs.ILabVendor
        | (Partial<labs.ILabVendor> & Required<Pick<labs.ILabVendor, "id">>);
}

export const initialStateLabsVendorConfigDrawer: ILabVendorConfigDrawer = {
    show: false,
    onCloseDrawer: undefined,
    labVendor: undefined,
};
const labsVendorConfigDrawerSlice = createSlice({
    name: "labsVendorConfigDrawer",
    initialState: initialStateLabsVendorConfigDrawer,
    reducers: {
        showLabsVendorConfigDrawer: (
            _state,
            action: PayloadAction<Omit<ILabVendorConfigDrawer, "show">>,
        ) => {
            return {
                ...action.payload,
                show: true,
            };
        },
        hideLabsVendorConfigDrawer: (_state) => {
            return initialStateLabsVendorConfigDrawer;
        },
    },
});

export const { showLabsVendorConfigDrawer, hideLabsVendorConfigDrawer } =
    labsVendorConfigDrawerSlice.actions;
export default labsVendorConfigDrawerSlice.reducer;
